import { KeyRound } from 'lucide-react';

import { SsoLoginCardProps } from '../../types/Login/auth.types';

const SsoLoginCard = ({
  showSSO,
  employeeCode,
  loading,
  error,
  onToggle,
  onEmployeeCodeChange,
  onSubmit,
}: SsoLoginCardProps) => {
  return (
    <div
      className="
        mt-[clamp(1rem,1.5vw,1.5rem)]
        w-full
      "
    >
      {/* ======================================================
          OR DIVIDER
      ====================================================== */}

      <div className="relative">
        <div
          className="
            absolute
            inset-0
            flex
            items-center
          "
        >
          <div
            className="
              w-full
              border-t
              border-slate-200
            "
          />
        </div>

        <div
          className="
            relative
            flex
            justify-center
          "
        >
          <span
            className="
              bg-white

              px-[clamp(0.5rem,0.8vw,0.75rem)]

              text-[clamp(11px,0.85vw,14px)]

              text-slate-500
            "
          >
            OR
          </span>
        </div>
      </div>

      {/* ======================================================
          SSO LOGIN BUTTON
      ====================================================== */}

      <button
        type="button"
        onClick={onToggle}
        className="
          mt-[clamp(0.9rem,1.4vw,1.25rem)]

          flex

          h-[clamp(40px,3.2vw,48px)]
          w-full

          items-center
          justify-center

          gap-1.5

          rounded-xl

          border
          border-blue-600

          px-4

          text-[clamp(13px,1vw,16px)]

          font-semibold

          text-blue-600

          transition-all
          duration-200

          hover:bg-blue-50
          hover:shadow-sm

          active:scale-[0.99]
        "
      >
        <KeyRound
          size={17}
          strokeWidth={2}
        />

        <span>
          SSO Login
        </span>
      </button>

      {/* ======================================================
          SSO FORM
      ====================================================== */}

      {showSSO && (
        <div
          className="
            mt-[clamp(0.75rem,1vw,1rem)]

            space-y-[clamp(0.75rem,1vw,1rem)]
          "
        >
          {/* Employee Code */}
          <input
            type="text"
            value={employeeCode}
            onChange={(e) =>
              onEmployeeCodeChange(
                e.target.value,
              )
            }
            placeholder="Enter Employee Code"
            className="
              h-[clamp(40px,3.2vw,48px)]
              w-full

              rounded-xl

              border
              border-slate-200

              bg-white

              px-[clamp(0.75rem,1vw,1rem)]

              text-[clamp(12px,0.9vw,14px)]

              text-slate-800

              outline-none

              placeholder:text-slate-400

              transition-all
              duration-200

              focus:border-green-500
              focus:ring-2
              focus:ring-green-500/20
            "
          />

          {/* Error */}
          {error && (
            <div
              className="
                rounded-lg

                border
                border-red-100

                bg-red-50

                px-3
                py-1.5

                text-[clamp(10px,0.75vw,12px)]

                leading-5

                text-red-500
              "
            >
              {error}
            </div>
          )}

          {/* Continue With SSO */}
          <button
            type="button"
            onClick={onSubmit}
            disabled={
              loading ||
              !employeeCode.trim()
            }
            className="
              h-[clamp(40px,3.2vw,48px)]
              w-full

              rounded-xl

              bg-green-600

              px-4

              text-[clamp(12px,0.9vw,14px)]

              font-semibold

              text-white

              transition-all
              duration-200

              hover:bg-green-700
              hover:shadow-sm

              disabled:cursor-not-allowed
              disabled:opacity-50
            "
          >
            {loading
              ? 'Signing In...'
              : 'Continue with SSO'}
          </button>
        </div>
      )}
    </div>
  );
};

export default SsoLoginCard;